import {useEffect} from 'react'
import {useAppDispatch, useAppSelector} from '../hooks'
import {
  selectIsUserFeedbackAgreed,
  selectEventDetails,
  selectIsRecording,
  setIsUserFeedbackAgreed,
  setEventDetails,
  setIsRecording
} from '../slices/userFeedbackSlice'
import {useGetEventDetails} from '../../api/queries/getEventDetailsQuery'
import {useUpdateEventDetails} from '../../api/queries/updateEventDetailsMutation'

// COMPLEX HOOK - For backward compatibility and convenience
// Use when: Migrating from Context, need all user feedback functionality together
export const useUserFeedback = () => {
  const dispatch = useAppDispatch()
  const isUserFeedbackAgreed = useAppSelector(selectIsUserFeedbackAgreed)
  const eventDetails = useAppSelector(selectEventDetails)
  const isRecording = useAppSelector(selectIsRecording)

  // GraphQL queries/mutations - keeping the same as original provider
  const {data: fetchedEventDetails, loading: loadingEventDetails, error: errorEventDetails} = useGetEventDetails()
  const [updateEventDetailsMutation, {loading: updateEventDetailsLoading, error: updateEventDetailsError}] =
    useUpdateEventDetails()

  // Initialize from sessionStorage on mount
  useEffect(() => {
    if (sessionStorage.getItem('eventParticipantJob')) {
      dispatch(setIsUserFeedbackAgreed(true))
    }
  }, [dispatch])

  // Sync fetched event details to Redux store
  useEffect(() => {
    if (fetchedEventDetails?.eventDetails) {
      dispatch(setEventDetails(fetchedEventDetails.eventDetails))
    }
  }, [fetchedEventDetails, dispatch])

  return {
    eventDetails,
    isRecording,
    loadingEventDetails,
    errorEventDetails,
    updateEventDetailsMutation,
    updateEventDetailsLoading,
    updateEventDetailsError,
    setEventDetails: (value) => dispatch(setEventDetails(value)),
    setIsRecording: (value) => dispatch(setIsRecording(value)),
    isUserFeedbackAgreed,
    setIsUserFeedbackAgreed: (value) => dispatch(setIsUserFeedbackAgreed(value))
  }
}

// SIMPLE SELECTOR HOOKS - For targeted access
// Use when: Only need specific values, performance-critical components
export const useIsUserFeedbackAgreed = () => useAppSelector(selectIsUserFeedbackAgreed)
export const useEventDetails = () => useAppSelector(selectEventDetails)
export const useIsRecording = () => useAppSelector(selectIsRecording)
